// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { useFlag } from '@calendly/feature-check-react';
import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { PageHeader } from '@calendly/ui/components/page-header';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { EmptyState, EMPTY_STATE_TYPES } from 'components/empty_state';
import { useNewEmptyStates, CONTENT_PAGES } from 'features/empty_state';
import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context';
import { UpgradeBanner } from 'features/upgrade_banner';
import { currentOrganizationSelector } from 'selectors/current_organization';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
import { Content } from './content';
import { ExperimentContent } from './experiment_content';
import { useHasSeenNotification } from '../../hooks';
import { featuresSelector } from '../../selectors';
const dashboardContainerCss = "d1ftk1l8";
const DashboardContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dashboardContainerCss, props.className)} />;
});
const titleWrapperCss = "t1y2rf6q";
const TitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleWrapperCss, props.className)} />;
});
export const EmptyDashboard = () => {
  usePageTitle(I18n.t('publisher.admin.dashboard.title'));
  const inSettingsModal = useIsSettingsModalLayout();
  const isNewBadgeHidden = useFlag('remove_new_flags_comp');
  const adminNotificationIconEnabled = useFlag('org_expansion_admin_notification_badge');
  const [hasSeenNotification, setHasSeenNotification] = useHasSeenNotification();
  const isNewEmptyStateEnabled = useNewEmptyStates();
  const features = useSelector(featuresSelector);
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector);
  const {
    is_trial: isTrial
  } = useSelector(currentOrganizationSelector);
  useEffect(() => {
    if (adminNotificationIconEnabled && !hasSeenNotification) {
      setHasSeenNotification(true);
    }
  });
  if (isNewEmptyStateEnabled) {
    if (!features.includes('admin_dashboard') || !isOwnerOrAdmin) {
      return <>
          {!isTrial && <UpgradeBanner featureKey="admin_dashboard" contentKey={CONTENT_PAGES.adminDashboard} />}
          <EmptyState type={EMPTY_STATE_TYPES.preview} contentKey={CONTENT_PAGES.adminDashboard} featureKey={CONTENT_PAGES.adminDashboard}>
            <ExperimentContent />
          </EmptyState>
        </>;
    }
  }
  return <DashboardContainer>
      {!inSettingsModal && <PageHeader title={<TitleWrapper>
              {I18n.t('publisher.admin.dashboard.title')}
              {!isNewBadgeHidden && <Badge type="new">{I18n.t('publisher.components.badge.new')}</Badge>}
            </TitleWrapper>} description={I18n.t('publisher.admin.dashboard.description')} />}
      <Content />
    </DashboardContainer>;
};

require("./empty_dashboard.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./empty_dashboard.js");